angular.module('bmsApp.resource')
	.controller('ResourceResourceRenameDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'resource',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  resource) {

			var self = this;
			var form = {
				validator: {
					config: {},
					api: {}
				},
				processing: false
			};
			angular.extend(self, {
				resource: resource,
				form: form,
				methods: {
					cancel: cancel,
					submit: submit
				}
			});

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit(form) {
				if (form.$valid) {
					ResourceSvc.resource.update(self.resource)
						.then(function () {
							notify({
								message: 'File renamed successfully.'
							});
							$modalInstance.close();
						}, function (errors) {
							ResourceSvc.displayErrors(errors);
						});
				}
			}

		}
	]);
